import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import { Loader } from 'react-loaders';

import { getRequest } from '../../../../../../api/ApiService';
import { teamsEndpoint } from '../../../../../../api/Teams';
import Auth from '../../../../../../routes/Auth';

import { handleSelectChange, arrayUniqueFilter } from '../../../utils';
import Image from '../../../../../../containers/assets/pf28.png';

import BannerLayout from '../../../layouts/banner';

class MarketShareStep6 extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      teamsToShow: [],
      selectedTeamId: 0,
      allTeamsCount: 0
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.setState({
      loaded: false
    });

    const { performanceFeedbacksGame } = this.props;

    getRequest(
      teamsEndpoint()
    ).then(res => {
      const teamsToShowIds = performanceFeedbacksGame.find(i => i.type === "Place").teams.filter(arrayUniqueFilter);

      const teams = res.body;
      const teamsToShow = teams.filter(i => teamsToShowIds.includes(i.id));

      const temporaryId = Auth.getTeamId();
      const team_id = teamsToShowIds.includes(temporaryId)
        ? temporaryId
        : teamsToShowIds[0];

      this.setState({
        loaded: true,
        teamsToShow,
        selectedTeamId: Number(team_id),
        allTeamsCount: teams.length,
      })
    })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      teamsToShow,
      selectedTeamId,
      allTeamsCount
    } = this.state;

    const { previousShownErrors } = this.props;

    return loaded ? (
      <BannerLayout
        section="Why Targets Weren’t Hit"
        subSection="Market share"
        alertText={`${teamsToShow.length} out of ${allTeamsCount} teams are selecting less optimal sales channels`}
        previousShownErrors={previousShownErrors}
        paragraph2={(
          <Fragment>
            <p>These teams are choosing sub-optimal sales channels. This, however, could be part of their strategy.</p>
            <p>In this game, teams have to choose between selling directly to customers or through a 3rd party distributor. The 3rd party distribution channel makes sense if a team is targeting the few customers that account for only 10% of overall demand (Customer 1, 7,8, and 14). If these are the only customers that the below teams are targeting, then they’ll have a challenge in hitting their market share target and possibly their revenue target.</p>
          </Fragment>
        )}
        selectorOptions={teamsToShow}
        selectorSelectedOptionId={selectedTeamId}
        onSelectorChange={value => handleSelectChange(value, this.fetchData)}
        visual={(
          <img src={Image} alt="Direct vs. Indirect Channels" />
        )}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }
}

export default MarketShareStep6;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/why-targets-werent-hit/market-share/step6.js